import React, { useState, useEffect } from "react";
import Header from "../../Core/Header";
import axios from "axios";
import { getShopOwnerList, userAdd, userList } from "../../Services/Operations/ProductAPI";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { setLoginData } from "../../Redux/user_information";
import { useNavigate } from "react-router-dom";
import { Section } from "../../Core/Section";
import { useSelector } from "react-redux";

const ShopOwner = () => {
  const token = useSelector((state) => state.user.token);
  console.log("token : ", token);
  const [user, setUser] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [cartUpdated, setUserUpdated] = useState(false);
  const [formData, setFormData] = useState({
    commonUserId: "",
    aadhaarImage: null,
    shopName: "",
    shopAddress: "",
    shopLogoFile: null,
    shopOwnerGstNumber: ""
  });

  const[currentuser,setCurrentUser]=useState(null)
  


              const [currentPage, setCurrentPage] = useState(1);
            const itemsPerPage = 10;
            
            const indexOfLast = currentPage * itemsPerPage;
            const indexOfFirst = indexOfLast - itemsPerPage;
            
            const currentUsers = user.slice(indexOfFirst, indexOfLast);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: value }); 
    }
  };
  

  const handleSubmit = async (e) => {
    e.preventDefault();
    // try {
    //   const payload = new FormData();
    //   Object.keys(formData).forEach((key) => {
    //     payload.append(key, formData[key]);
    //   });
  
    //   // const response = await shopOwnerAdd(payload, token); 
    //   console.log("response of user added:", response);
  
    //   if (response.status === 200) {
    //     toast.success("User added successfully");
    //     dispatch(setLoginData(response.data.id));
    //     setUserUpdated((prev) => !prev);
    //   } else {
    //     toast.error(response.data.message);
    //   }
    // } catch (error) {
    //   console.error("Error:", error);
    //   toast.error("Something went wrong");
    // }
  };

  const handleFetchShop=async()=>{
    try {
      const response=await getShopOwnerList(token)
      console.log(response);
      setUser(response.data)
      
      
    } catch (error) {
      console.log(error);
      
    }
  }

  useEffect(() => {
    handleFetchShop()
  }, [])
  
  

  // useEffect(() => {
  //   const fetchUserList = async () => {
  //     try {
  //       const response = await userList(token);
  //       console.log("user list:", response);
  //       setUser(response);
  //     } catch (error) {
  //       console.error("Error updating profile:", error);
  //     }
  //   };

  //   fetchUserList();
  // }, [cartUpdated]);


  return (
    <div id="main_content">
      <Header />
      <div className="page">
        <Section />
        <div className="section-body">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center ">
              <div className="header-action">
                <h1 className="page-title">Users</h1>
                <ol className="breadcrumb page-breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#">RNDSAN</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Shop owner (chamber)
                  </li>
                </ol>
              </div>
              <ul className="nav nav-tabs page-header-tab">
                <li className="nav-item">
                  <a
                    className="nav-link active"
                    data-toggle="tab"
                    href="#Student-all"
                  >
                    List View
                  </a>
                </li>
                <li className="nav-item"
                onClick={()=>navigate('/chamber-add')}>
                  <button
                  className="doctor-primary-btn"
                    
                    data-toggle="tab"
                    href="#Student-all"
                  >
                    Add New
                  </button>
                </li>
               
               
              </ul>
            </div>
          </div>
        </div>
        <div className="section-body mt-4">
          <div className="container-fluid">
            <div className="tab-content">
              <div className="tab-pane active" id="Student-all">
              
                <div className="table-responsive card">
                  <table className="table table-hover table-vcenter table-striped mb-0 text-nowrap">
                    <thead>
                      <tr>
                        <th style={{textAlign:"center"}}>Id</th>
                        <th/>
                        <th style={{textAlign:"center"}}>Name</th>
                     
                        <th style={{textAlign:"center"}}>Address</th>
                        
                        <th style={{textAlign:"center"}}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentUsers?.map((user,ind) => (
                        <tr key={user?.id}>
                          <td>{indexOfFirst+ind+1}</td>
                          <td className="w60">
                            <img
                              className="avatar"
                              src="../assets/images/xs/avatar1.jpg"
                              alt=""
                            />
                          </td>
                          <td>
                            <span className="font-16">{user?.shopName}</span>
                          </td>
                          <td>{user?.shopAddress}</td>
                        
                         
                          <td>
                            <button onClick={()=>setCurrentUser(user)}
                              type="button"
                              className="btn btn-icon btn-sm"
                              title="View"
                            >
                              <i className="fa fa-eye" />
                            </button>
                            
                           
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                               <div className="pagination mt-3" style={{display:"flex",alignItems:"center",justifyContent:"center"}}>
                             <button
    disabled={currentPage === 1}
    onClick={() => setCurrentPage((prev) => prev - 1)}
    className="btn btn-primary btn-sm me-2"
  >
    Prev
                     </button>

                      <span> Page {currentPage} of {Math.ceil(user.length / itemsPerPage)} </span>

                  <button
    disabled={currentPage === Math.ceil(user.length / itemsPerPage)}
    onClick={() => setCurrentPage((prev) => prev + 1)}
    className="btn btn-primary btn-sm ms-2"
  >
    Next
               </button>
                        </div>
                </div>
              </div>
             
              <div className="tab-pane" id="Student-add">
                <div className="row clearfix">
                  <div className="col-lg-8 col-md-12 col-sm-12">
                    <div className="card">
                      <div className="card-header">
                        <h3 className="card-title">Basic Information</h3>
                        <div className="card-options ">
                          <a
                            href="#"
                            className="card-options-collapse"
                            data-toggle="card-collapse"
                          >
                            <i className="fe fe-chevron-up" />
                          </a>
                          <a
                            href="#"
                            className="card-options-remove"
                            data-toggle="card-remove"
                          >
                            <i className="fe fe-x" />
                          </a>
                        </div>
                      </div>
                      <form className="card-body" onSubmit={handleSubmit}>
  <div className="form-group row">
    <label className="col-md-3 col-form-label">Common User ID<span className="text-danger">*</span></label>
    <div className="col-md-9">
      <input
        type="number"
        name="commonUserId"
        className="form-control"
        placeholder="Enter User ID"
        value={formData.commonUserId}
        onChange={handleChange}
        required
      />
    </div>
  </div>

  <div className="form-group row">
    <label className="col-md-3 col-form-label">Aadhaar Image<span className="text-danger">*</span></label>
    <div className="col-md-9">
      <input
        type="file"
        name="aadhaarImage"
        className="form-control"
        onChange={handleChange}
        required
      />
    </div>
  </div>

  <div className="form-group row">
    <label className="col-md-3 col-form-label">Shop Name<span className="text-danger">*</span></label>
    <div className="col-md-9">
      <input
        type="text"
        name="shopName"
        className="form-control"
        placeholder="Enter Shop Name"
        value={formData.shopName}
        onChange={handleChange}
        required
      />
    </div>
  </div>

  <div className="form-group row">
    <label className="col-md-3 col-form-label">Shop Address<span className="text-danger">*</span></label>
    <div className="col-md-9">
      <input
        type="text"
        name="shopAddress"
        className="form-control"
        placeholder="Enter Shop Address"
        value={formData.shopAddress}
        onChange={handleChange}
        required
      />
    </div>
  </div>

  <div className="form-group row">
    <label className="col-md-3 col-form-label">Shop Logo File<span className="text-danger">*</span></label>
    <div className="col-md-9">
      <input
        type="file"
        name="shopLogoFile"
        className="form-control"
        onChange={handleChange}
        required
      />
    </div>
  </div>

  <div className="form-group row">
    <label className="col-md-3 col-form-label">GST Number<span className="text-danger">*</span></label>
    <div className="col-md-9">
      <input
        type="text"
        name="shopOwnerGstNumber"
        className="form-control"
        placeholder="Enter GST Number"
        value={formData.shopOwnerGstNumber}
        onChange={handleChange}
        required
      />
    </div>
  </div>

  <div className="col-sm-12">
    <button type="submit" className="btn btn-primary">Submit</button>
  </div>
</form>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {
          currentuser && (<div style={{position:"absolute",top:"100px",right:"200px",zIndex:999,backgroundColor:"white",padding:"14px",border:"0.5px solid gray",borderRadius:"10px",minWidth:"450px"}}>
          <div  role="dialog">
            <p onClick={()=>setCurrentUser(null)} 
            style={{position:"absolute",right:"10px",cursor:"pointer",fontSize:"13px",padding:"5px",height:"30px",width:"30px",backgroundColor:"#cacacaff",borderRadius:"50%",display:"flex",alignItems:"center",justifyContent:"center"}}>X</p>
            <div  role="document">
              <p style={{fontSize:"20px",fontWeight:"800"}}>Shop Name:{currentuser.shopName}</p>
              <p style={{fontWeight:"600",color:"#999999ff"}}>Shop Owner id:{currentuser.shopOwnerId}</p>
              <p style={{fontWeight:"600",color:"#999999ff"}}>Address:{currentuser.shopAddress}</p>
              <p style={{fontSize:"14px"}}>Latitude-{currentuser.latitude||0},Longitude-{currentuser.longitude||0}</p>
              <p style={{fontSize:"14px"}}>Shop Document:{currentuser.shopDocument}</p>
              <p style={{fontSize:"14px"}}>Product Commissions:[]</p>
              <p style={{fontSize:"14px"}}>Service Commissions:[]</p>
              </div>
            </div>
          </div>)
        }
        <div className="section-body">
          <footer className="footer">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  Copyright © 2025{" "}
                  <a href="">Technology support By - Siance Software Pvt Ltd</a>
                  .
                </div>
                {/* <div className="col-md-6 col-sm-12 text-md-right">
                  <ul className="list-inline mb-0">
                    <li className="list-inline-item">
                      <a href="../doc/index.html">Documentation</a>
                    </li>
                    <li className="list-inline-item">
                      <a href="javascript:void(0)">FAQ</a>
                    </li>
                    <li className="list-inline-item">
                      <a
                        href="javascript:void(0)"
                        className="btn btn-outline-primary btn-sm"
                      >
                        Buy Now
                      </a>
                    </li>
                  </ul>
                </div> */}
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};
export default ShopOwner;
